import { getCookie, setCookie } from "./cookie.qwik.mjs";
import { checkIsDefined } from "./nullable.qwik.mjs";
import { uuid } from "./uuid.qwik.mjs";
const SESSION_LOCAL_STORAGE_KEY = "builderSessionId";
const getSessionId = async ({ canTrack }) => {
  if (!canTrack)
    return void 0;
  const sessionId = await getCookie({
    name: SESSION_LOCAL_STORAGE_KEY,
    canTrack
  });
  if (checkIsDefined(sessionId))
    return sessionId;
  else {
    const newSessionId = createSessionId();
    setSessionId({
      id: newSessionId,
      canTrack
    });
    return newSessionId;
  }
};
const createSessionId = () => uuid();
const setSessionId = ({ id, canTrack }) => setCookie({
  name: SESSION_LOCAL_STORAGE_KEY,
  value: id,
  canTrack
});
export {
  createSessionId,
  getSessionId,
  setSessionId
};
